import { Box, TextNew } from '@jfs/ui-new'
import { FC, ReactNode } from 'react'
import { AepsButton } from '../../comps/AepsButton'

interface BillerCardProps {
  displayName: string
  minAmount: string | number
  maxAmount: string | number
  isBbps: 'Y' | 'N'
  onPress: (displayName: string) => void
  handleCreateOrderAPI: (details: any) => void
  selectedPlanDetails: any
  children?: ReactNode
}

export const BillerCard: FC<BillerCardProps> = ({ displayName, minAmount, maxAmount, isBbps, onPress, handleCreateOrderAPI, // Destructure new prop
  selectedPlanDetails,  // Destructure new prop
  children 
 }) => {
  const parsedMinAmount = typeof minAmount === 'string' ? parseFloat(minAmount) : minAmount
  const parsedMaxAmount = typeof maxAmount === 'string' ? parseFloat(maxAmount) : maxAmount
  const isBBPSEnabled = isBbps === 'Y'
  const handlePress = () => onPress(displayName)

  const handleRechargePress = () => {
    handleCreateOrderAPI(selectedPlanDetails)
  }


  // console.log(`Rendering BillerCard for: ${displayName}. BBPS: ${isBBPSEnabled}`)

  return (
    <Box marginBottom={30}>
      <Box padding={14} borderRadius={16} customShadowStyle="shadowPrimary">
        {/* <Box flexDirection={'row'} justifyContent={'space-between'}>
          <Box flexDirection={'row'} gap={20}>
            <TextNew fontSize={14} color={isBBPSEnabled ? 'BRAND_PRIMARY_RED' : 'BRAND_COLOR_GRAY_1'}>
              {isBBPSEnabled ? 'TRUE 5G' : 'TRUE 5G'}
            </TextNew>
            <TextNew fontSize={12} color="BRAND_PRIMARY_BG">
              {isBBPSEnabled ? 'Unlimited 5G Data' : 'Unlimited 5G Data'}
            </TextNew>
          </Box>
        </Box> */}
        <Box flexDirection={'row'} width={'100%'} justifyContent={'space-between'} marginTop={8}>
          <Box flex={1} marginRight={10}>
            <TextNew fontSize={18} color="BLACK" fontWeight={'700'}>
              {displayName}
            </TextNew>
          </Box>
          <Box onPress={handlePress}>
            <TextNew fontSize={14} color="BRAND_PRIMARY_ACTION">
              View Details
            </TextNew>
          </Box>
        </Box>
        <Box borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} marginTop={12} marginBottom={12} />

        {children}

        {/* <Box borderTopWidth={1} borderColor={'PRIMARY_GREY'} width={'100%'} marginTop={12} marginBottom={12} />

        <Box flexDirection={'row'} justifyContent={'space-between'}>
          <Box>
            <TextNew fontSize={12} color={'BRAND_COLOR_GRAY_1'}>
              Min Amount
            </TextNew>
            <TextNew fontSize={15} color="BRAND_PURE_BLACK" fontWeight={'700'}>
              ₹{parsedMinAmount.toFixed(2)}
            </TextNew>
          </Box>
          <Box>
            <TextNew fontSize={12} color={'BRAND_COLOR_GRAY_1'}>
              Max Amount
            </TextNew>
            <TextNew fontSize={15} color="BRAND_PURE_BLACK" fontWeight={'700'}>
              ₹{parsedMaxAmount.toFixed(2)}
            </TextNew>
          </Box>
          <Box>
            <TextNew fontSize={12} color={'BRAND_COLOR_GRAY_1'}>
              Payment Type
            </TextNew>
            <TextNew fontSize={15} color="BRAND_PURE_BLACK" fontWeight={'700'}>
              {isBBPSEnabled ? 'BBPS' : 'INSTAPAY'}
            </TextNew>
          </Box>
        </Box> */}

        {/* 5. Action Button */}
        {/* FIX: Replaced invalid 'justify' with 'justifyContent' and removed unnecessary width */}
        <Box marginTop={15} justifyContent={'center'}>
          <AepsButton  onPress={handleRechargePress} 
          // onPress={handlePress} 
          title={'Recharge'} disabled={false} />
        </Box>
      </Box>
    </Box>
  )
}
